import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@tellescope/ui";
import { Loader2 } from "lucide-react";
import { useCompleteSSO } from "./useCompleteSSO";

export const CompleteSSOPage = () => {
  const { t } = useTranslation("auth");
  const { isLoading, error } = useCompleteSSO();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">
            {error ? t("SSO Login Failed") : t("Completing Sign In")}
          </CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
          {isLoading && (
            <div className="flex items-center gap-2 text-muted-foreground">
              <Loader2 className="h-5 w-5 animate-spin" />
              <span>{t("Completing sign in...")}</span>
            </div>
          )}

          {error && (
            <>
              <div className="text-sm text-destructive bg-destructive/10 p-3 rounded-md w-full text-center">
                {error}
              </div>
              <Link to="/login" className="text-sm text-primary hover:underline">
                {t("Back to login")}
              </Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
